module.exports = __webpack_public_path__ + "static/media/class-invite-2.1.3e499de1.PNG";